define('controllers/myreport/myreport-account.ctrl',['app'], function (app) {
    app.controller('AccountReport', ['$scope', '$q', 'OpenApp', 'OpenOther', 'reportUtil', 'auiDialog', '$state',
        function ($scope, $q, OpenApp, OpenOther, reportUtil, auiDialog, $state) {
            $scope.angularHandover4AccountReport = sysParamCfg.switchConf.angularHandover4AccountReport;

            if (sysParamCfg.switchConf.angularHandover4AccountReport) {
                $state.go('accountReport');
                return;
            }
            /* 1. 局部变量声明 */
            var localVariable = 'local variable';
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                magicType: 'line',
                queryAccount: {
                    appId: '-1',                  //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('account', 32),
                    regionShow: [0, 3, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),       //【开始时间】【默认值】今天
                    endTime: new Date(),         //【结束时间】【默认值】今天
                    timeQuantum: 31,                 //【允许的时间跨度】默认值是不限制
                    //queryType:1,                //【时间类型】【默认值】1【枚举】1:购买时间2:退款时间
                    //tradeId:'',                 //【订单编号】【默认值】空
                    //tradeStatus:-1,             //【订单状态】【默认值】-1【枚举】-1:全部状态1:预扣2:确认扣除3:预扣解除4:直接扣除成功5:直接扣除失败6:退款成功
                    //sdkChannel:-1,              //【推广渠道】【默认值】-1【枚举】-1:全部0:华为应用1:华为应用市场渠道2:预装渠道，3:游戏吧
                    //status:-1                   //【结算状态】【默认值】-1【枚举】-1:全部0:待确认1:已确认
                    queryMethod: queryAccountList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadAccountList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    onload: init
                },
                paginationAccount: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No Data",
                    pagesLength: 5,
                    onChange: pageChangeAccount
                },
                accountList: [],
                accountCharts: {
                    id: "myreport_account",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                }
            };
            Model.variableOfScope = 'variable of scope';
            /* 3. $scope函数挂载 */
            $scope.queryAccountList = queryAccountList;
            $scope.downloadAccountList = downloadAccountList;

            /* 4. 初始化函数声明与执行 */
            function init() {
                // 进入页面就查询一遍
                queryAccountList();
            }

            /* 5. 函数声明 */
            function queryAccountList() {
                var request = {
                    pageSize: 31,
                    pageNum: 1
                };
                AUI.BaseJSUtil.mergeJSON(Model.queryAccount, request);
                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                OpenOther.getReportAccountList(request).then(function (resp) {
                    Model.accountList = resp;
                    Model.paginationAccount.totalCount = Model.accountList.total;
                    Model.paginationAccount.currentPage = 1;
                    Model.paginationAccount.itemsPerPage = Model.paginationAccount.itemsPerPageBackUp;
                    getEchartConfig();
                    pageChangeAccount();
                });
            }

            function downloadAccountList() {
                var request = {
                    appId: Model.queryAccount.appId,
                    startTime: Model.queryAccount.startTime,
                    endTime: Model.queryAccount.endTime
                };
                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReportAccountList, request, function (resp) {
                    return resp.retCode == 0;
                });
            }

            function getEchartConfig() {
                var result = reportUtil.getXYFromBI(Model.accountList.reportAccountList, "date", 1,
                    ["totalAccount", "newAccount", "activeAccount"]);
                Model.accountCharts.options = (result && result['date'] && result['date'].length > 0) ? {
                    legend: {
                        data: ['总用户数', '新增用户数', '活跃用户数']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["date"]
                    }],
                    yAxis: [{ // 纵坐标
                        type: 'value'
                    }],
                    series: [{
                        "name": "总用户数",
                        "type": Model.magicType,
                        "data": result["totalAccount"]
                    }, {
                        "name": "新增用户数",
                        "type": Model.magicType,
                        "data": result["newAccount"]
                    }, {
                        "name": "活跃用户数",
                        "type": Model.magicType,
                        "data": result["activeAccount"]
                    }]
                } : null;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeAccount() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.accountList.reportAccountList, Model.paginationAccount));
                Model.accountListFowTable = result.listForShow;
            }

            //代码是返回的范例代码  不应该展示
            function getAccountInfo() {

                var list = [{
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "444",
                    activeAccount: "1234",
                    totalAccount: "3251",
                    date: "2016-01-03"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "454",
                    activeAccount: "1434",
                    totalAccount: "3351",
                    date: "2016-01-02"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "464",
                    activeAccount: "1134",
                    totalAccount: "3151",
                    date: "2016-01-01"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "474",
                    activeAccount: "1534",
                    totalAccount: "3451",
                    date: "2016-01-05"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "484",
                    activeAccount: "1634",
                    totalAccount: "3551",
                    date: "2016-01-06"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "494",
                    activeAccount: "1034",
                    totalAccount: "2951",
                    date: "2016-01-04"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "524",
                    activeAccount: "1084",
                    totalAccount: "2951",
                    date: "2016-01-07"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "514",
                    activeAccount: "1384",
                    totalAccount: "3091",
                    date: "2016-01-09"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "504",
                    activeAccount: "1184",
                    totalAccount: "3291",
                    date: "2016-01-09"
                }, {
                    publisherId: "123456",
                    appId: "-1",
                    newAccount: "534",
                    activeAccount: "1284",
                    totalAccount: "3191",
                    date: "2016-01-10"
                }];

                return {
                    requestId: "",
                    systemId: "",
                    returnCode: 200,
                    returnDesc: "No Data",
                    total: "45",
                    totalAccountNow: "3251",
                    reportAccountList: list.slice(0, ~~(Math.random() * 10))
                }
            }
        }]
    );
});
